import {
  USER_STATUS_ARCHIVED,
  USER_STATUS_PENDING,
  USERSTATUSIDS
} from "./constants/appConstants";

/**
 * Account statuses that still see onboarding.
 *
 * Pending, Archived and Customer DD are the statuses waiting on a funding
 * decision. An account outside this set — Approved, Not Approved,
 * Pre-Approved, or anything unmapped — sees no onboarding at all: not the
 * tasks banner, not the post-login redirect, not the invoice dashboard's
 * prompt, and not the `/onboarding` page by URL.
 *
 * Status is the trigger because unfinished onboarding is normal and FundTap
 * collects the rest by hand. `UserStatusServiceImpl.updateUserStatus` sets the
 * status with no onboarding check, so an account can be Approved with
 * documents still outstanding; once it has a funding decision the manual
 * follow-up is the process, and sending that customer to finalise a setup the
 * team is already handling off-app duplicates the work. See
 * docs/decisions/0060.
 */
export const ONBOARDING_USER_STATUS_IDS = [
  USER_STATUS_PENDING,
  USER_STATUS_ARCHIVED,
  USERSTATUSIDS.CUSTOMER_DD
];

/**
 * Whether an account in this status sees onboarding.
 *
 * A missing status is not one of the three, so it answers false. Every caller
 * fetches the profile, and treating an unknown status as "no onboarding"
 * keeps a half-loaded store from pushing a customer into a flow that may hold
 * nothing for them.
 */
export const isOnboardingUserStatus = (userStatusId) =>
  userStatusId !== null &&
  userStatusId !== undefined &&
  ONBOARDING_USER_STATUS_IDS.includes(Number(userStatusId));
